import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { getLastResults, getDetailResults } from '../../../../apiservices/CasionApi';
import RefResultModal from '../../../casinoComponents/refResultModal';
import DoliDanaResultBody from '../../../casinoComponents/refResultModal/DoliDanaResultBody';
import { formatRefMatchTime } from '../../../../utils/refMatchTime';

/**
 * Last Result items for Doli Dana in the reference markup — rendered inside `.casino-video-last-results`:
 *   every round → <span class="resulttie">R</span>
 * Click → full-page .loader-overlay while the round detail loads, then the reference result modal.
 */
const ResultDoliDana = ({ gameType = 'dolidana' }) => {
  const apiType = (gameType || 'dolidana').toLowerCase().trim();
  const [lastResults, setLastResults] = useState([]);
  const [detailResult, setDetailResult] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchLastResults = async () => {
      try {
        const response = await getLastResults(apiType);
        if (response?.data?.data?.res) {
          setLastResults(response.data.data.res.map((item) => ({ mid: item.mid, win: item.win })));
        }
      } catch (error) {
        console.error('Error fetching last results:', error);
      }
    };
    fetchLastResults();
    const interval = setInterval(fetchLastResults, 5000);
    return () => clearInterval(interval);
  }, [apiType]);

  const handleResultClick = async (item) => {
    if (!item?.mid) return;
    setLoading(true);
    try {
      const response = await getDetailResults(apiType, item.mid.toString());
      const t1 = response?.data?.data?.t1 ?? response?.data?.t1;
      if (t1) {
        setDetailResult(t1);
        setShowModal(true);
      }
    } catch (error) {
      console.error('Error fetching detail results:', error);
    }
    setLoading(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setDetailResult(null);
  };

  return (
    <>
      {lastResults.map((item, index) => (
        <span key={item.mid || index} className="resulttie" onClick={() => handleResultClick(item)}>
          R
        </span>
      ))}
      {loading && createPortal(<div className="loader-overlay" />, document.querySelector('.page-content') || document.body)}
      <RefResultModal
        show={showModal && !loading && !!detailResult}
        onHide={handleCloseModal}
        // Reference title is "Doli dana Result"; our vendor's ename is "Doli Dana"
        title="Doli dana Result"
        roundId={detailResult?.rid}
        matchTime={formatRefMatchTime(detailResult?.mtime)}
      >
        <DoliDanaResultBody t1={detailResult} />
      </RefResultModal>
    </>
  );
};

export default ResultDoliDana;
